import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const refandiBannerComponent = {
  actionButton: 'refandi-banner.action-button',
  disclaimer: 'refandi-banner.disclaimer',
  iconImage: 'refandi-banner.icon-image',
  root: 'refandi-banner.root',
  savingsText: 'refandi-banner.savings-text',
  titleText: 'refandi-banner.title',
} as const satisfies ComponentLocatorMap;
